// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

const m0 = '<path d="M6.46 19L2 22.5V4A1 1 0 0 1 3 3H21A1 1 0 0 1 22 4V18A1 1 0 0 1 21 19Z"/>';

/** Chat (communication). */
const icon: IconData = {
  id: "chat",
  name: "Chat",
  category: "communication",
  styles: {
    rounded: { svg: m0 },
    sharp: { svg: m0 },
    outline: {
      svg: '<path d="M5.76 17H20V5H4V18.38ZM6.45 19L2 22.5V4A1 1 0 0 1 3 3H21A1 1 0 0 1 22 4V18A1 1 0 0 1 21 19Z"/>',
    },
    duotone: {
      svg: '<g opacity=".32"><path d="M21.39 3.08L21.71 3.29 21.92 3.61 22 4V18L21.92 18.39 21.71 18.71 21.39 18.92 21 19H6.45L2 22.5V4L2.08 3.61 2.29 3.29 2.61 3.08 3 3H21Z"/></g><path d="M5.76 17H20V5H4V18.38ZM6.45 19L2 22.5V4A1 1 0 0 1 3 3H21A1 1 0 0 1 22 4V18A1 1 0 0 1 21 19Z"/>',
    },
  },
  animation: () => import("../animations/chat.js"),
};

export default icon;
